import * as _ from 'lodash';
import { IWakeWord } from '../../models/IWakeWord';

export function getSelectedWakeWordIdByModelUrl(wakeWords: IWakeWord[], wakeWordModelUrl: string) {
    const selectedWakeWord = _.find(wakeWords, (wakeWord) => {
        if (JSON.parse(wakeWord.options).model_url === wakeWordModelUrl) {
            return wakeWord;
        } return null;
    }) as IWakeWord;
    return selectedWakeWord?.id;
}
